<!--<div *ngIf="isClose===false" class="notification-message-container" fxLayoutAlign="space-between center">
  <div>
    <span>Note:</span> <span>Please make sure you have provided a Start Date and Due Date for this Task (via the Details tab) before you create any occurrences.</span>
  </div>
  <button (click)="closeNote()" analyticsAction=""
          analyticsCategory=""
          mat-icon-button
          particleAnalytics>
    <mat-icon>close</mat-icon>
  </button>
</div>-->
<form [formGroup]="taskFormGroup" class="flex flex-col">

  <div class="flex flex-row justify-start items-start gap-12">
    <div class="flex flex-col">
      <mat-label class="m-b-10">
        <mat-checkbox (change)="onTaskStartDateChange()" [(ngModel)]="startDateEnabled"
                      [disabled]="!hasOccurrencePermission"
                      [ngModelOptions]="{standalone: true}">
          Start Date
        </mat-checkbox>
      </mat-label>
      <div class="flex flex-row justify-start items-start auto-flex">
        <mat-form-field appearance="outline" class="md-100">
          <input (dateInput)="onTaskStartDateChange()"
                 [disableControl]="!startDateEnabled || !hasOccurrencePermission"
                 [matDatepicker]="taskStartDatePicker"
                 [max]="(isSubTask && card.parentTicket?.startDate !== null)  ? maxStartDate : null"
                 [min]="(isSubTask && card.parentTicket?.startDate !== null)  ? minStartDate: null"
                 formControlName="taskStartDate"
                 matInput
                 particleDisableFormControl>
          <mat-datepicker-toggle [disabled]="!hasOccurrencePermission" [for]="taskStartDatePicker"
                                 matSuffix></mat-datepicker-toggle>
          <mat-datepicker #taskStartDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div class="flex flex-col">
      <mat-label class="m-b-10">
        <mat-checkbox (change)="onTaskDueDateChange()"
                      [(ngModel)]="dueDateEnabled"
                      [disabled]="!hasOccurrencePermission"
                      [ngModelOptions]="{standalone: true}">
          Due Date
        </mat-checkbox>
      </mat-label>
      <div class="flex flex-row justify-start items-start auto-flex">
        <mat-form-field appearance="outline" class="md-50">
          <input (dateInput)="onTaskDueDateChange()"
                 [disableControl]="!dueDateEnabled || !hasOccurrencePermission"
                 [matDatepicker]="taskDueDatePicker"
                 [max]="(isSubTask && card.parentTicket?.dueDate !== null)  ? maxDueDate: null"
                 [min]="(isSubTask && card.parentTicket?.dueDate !== null)  ? minDueDate: null"
                 formControlName="taskDueDate"
                 matInput
                 particleDisableFormControl>
          <mat-datepicker-toggle [disabled]="!hasOccurrencePermission" [for]="taskDueDatePicker"
                                 matSuffix></mat-datepicker-toggle>
          <mat-datepicker #taskDueDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div *ngIf="enableCreateOccurrence" class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-0-0-100">
      <mat-label>Repeat</mat-label>
      <mat-select (selectionChange)="onRepeatChanged()"
                  [disabled]="!hasOccurrencePermission"
                  formControlName="recurrenceInfo">
        <mat-option *ngFor="let recurrenceInfo of recurrenceInfos"
                    [value]="recurrenceInfo">
          {{recurrenceInfo.title}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="enableCreateOccurrence && selectedRecurrenceInfo && selectedRecurrenceInfo.type ==='Weekly'"
  >
    <label>Repeat On</label>
    <div class="week-day-selction-contianer flex flex-row">
      <button (click)="clickWeekDays(weekDay)"
              *ngFor="let weekDay of weekDays"
              [disabled]="!hasOccurrencePermission"
              [ngClass]="weekDay.isChecked? 'active': ''"
              analyticsAction="" analyticsCategory="" mat-icon-button
              particleAnalytics
      >{{weekDay.title}}
      </button>
    </div>
  </div>

  <div class="flex flex-row justify-start items-start gap-12 auto-flex"
       *ngIf=" enableCreateOccurrence && selectedRecurrenceInfo?.type !== 'OneTime'">
    <div class="flex flex-col">
      <mat-form-field appearance="outline" style="min-width:260px">
        <mat-label>Ends</mat-label>
        <mat-select (selectionChange)="onEndingTypeChanged($event)"
                    [disabled]="!isEndingTypeApplicable || !hasOccurrencePermission"
                    formControlName="endingType">
          <mat-option *ngFor="let endsType of endsTypes" [value]="endsType.key">
            {{endsType.title}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div *ngIf="taskFormGroup.get('endingType').value==='On'" class="flex flex-col">
      <mat-form-field appearance="outline" style="min-width:260px">
        <mat-label>End Date</mat-label>
        <input (dateChange)="onEndingDate($event)"
               [disableControl]="!startDateEnabled || !hasOccurrencePermission"
               [matDatepicker]="dueDatePicker"
               formControlName="endingDate"
               matInput
               particleDisableFormControl>
        <mat-datepicker-toggle
          [disabled]="!hasOccurrencePermission" [for]="dueDatePicker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #dueDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div *ngIf="taskFormGroup.get('endingType').value==='After'" class="flex flex-col">
      <mat-form-field appearance="outline" style="min-width:260px">
        <mat-label>Occurrences</mat-label>
        <input (change)="endingOccurrenceCountChanged()"
               [disableControl]="!isEndingTypeApplicable || !hasOccurrencePermission"
               formControlName="endingOccurrenceCount"
               id="fontSize" matInput min="0"
               particleDisableFormControl
               type="number"/>
      </mat-form-field>
    </div>
  </div>

  <!--<div fxLayout="column" class="m-t-10 m-lr-30">
    <div>Ends</div>
    <div fxLayout="row" fxLayoutAlign="start start" fxFlex="0 0 auto">
      <mat-radio-group fxLayout="column"
                       aria-label="Ends"
                       formControlName="endingType"
                       (change)="onEndingTypeChanged($event)"
                       [disabled]="!isEndingTypeApplicable"
      >
        <table class="m-b-10">
          <tr>
            <td class="p-r-10">
              <mat-radio-button class="fontSize14" value="Never">Never
              </mat-radio-button>
            </td>
            <td><mat-radio-button class="fontSize14" value="On">On
            </mat-radio-button>
            </td>
            <td class="p-r-10">
              <div fxLayout="row" fxLayoutAlign="start center">
                <div fxLayout="row" fxLayoutAlign="start start">
                  <mat-form-field appearance="outline" fxFlex="0 0 100" fxFlex.md="0 0 100">
                    <input matInput formControlName="endingDate" [matDatepicker]="dueDatePicker"
                           [disabled]="!isEndingTypeApplicable"
                           (dateChange)="onEndingDate($event)">
                    <mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #dueDatePicker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

            </td>
            <td><mat-radio-button class="fontSize14" value="After">
              After
            </mat-radio-button></td>
            <td>
              <mat-form-field appearance="outline" style="max-width:181px">
                <input matInput id="fontSize" type="number"
                       min="8" formControlName="endingOccurrenceCount" [disabled]="!isEndingTypeApplicable"
                       (change)="endingOccurrenceCountChanged()"/>
              </mat-form-field>
            </td>
          </tr>
        </table>





        &lt;!&ndash;<table>
          <tr>
            <td>
              <mat-radio-button class="fontSize14" value="Never">Never
              </mat-radio-button>
            </td>
            <td>
            </td>
          </tr>
          <tr>
            <td><mat-radio-button class="fontSize14" value="On">On
            </mat-radio-button>
            </td>
            <td>
              <div fxLayout="row" fxLayoutAlign="start center">
                <div fxLayout="row" fxLayoutAlign="start start" fxFlex="0 0 80">
                  <mat-form-field appearance="outline" fxFlex="0 0 100" fxFlex.md="0 0 100">
                    <input matInput formControlName="endingDate" [matDatepicker]="dueDatePicker"
                           [disabled]="!isEndingTypeApplicable"
                           (dateChange)="onEndingDate($event)">
                    <mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #dueDatePicker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

            </td>
          </tr>
          <tr>
            <td><mat-radio-button class="fontSize14" value="After">
              After
            </mat-radio-button></td>
            <td>
              <mat-form-field appearance="outline" style="max-width:181px">
                <input matInput id="fontSize" type="number"
                       min="8" formControlName="endingOccurrenceCount" [disabled]="!isEndingTypeApplicable"
                       (change)="endingOccurrenceCountChanged()"/>
              </mat-form-field>
            </td>
          </tr>
        </table>&ndash;&gt;

      </mat-radio-group>


    </div>
  </div>-->
  <div *ngIf="enableCreateOccurrence" class="modal-footer m-t-10 flex flex-row justify-start items-center">
    <button (click)=onClickCreateOccurrences() [disabled]="!canCreateOccurrences || !hasOccurrencePermission"
            analyticsAction="done-btn" analyticsCategory="file-dialog"
            class="action-button"
            mat-button
            particleAnalytics
            type="button"
    >
      Create More Occurrences
    </button>
    <div class="m-l-20">
      <strong>Please note:</strong> the notification settings from this current task will be automatically applied to
      any additional occurrences of this task.
    </div>
  </div>
  <div *ngIf="enableCreateOccurrence" class="content pos-relative m-t-30 flex flex-col full-grow-no-shrink-no-basis">
    <div class="keno-grid-container">
      <particle-virtual-grid
        [invalidateSubject]="invalidateSubject"
        [parameters]="parameters"
        [sourceKey]="sourceKey"
        [serviceName]="serviceName"
        [api]="taskManagerService.api"
        (selectionChanged)="onSelectionChanged($event)"
        (valueChanged)="onGridCellValueChange($event)"
        [invalidateSubject]="invalidateSubject"
        [sourceKey]="sourceKey"
        sortFieldKey="StartDate">
      </particle-virtual-grid>
    </div>
  </div>

</form>
